import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Player, TrackType } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
export interface Track {
  type: TrackType;
  language: string;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-player-audio-subtitles-dialog',
  templateUrl: './player-audio-subtitles-dialog.component.html',
  styleUrls: ['./player-audio-subtitles-dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlayerAudioSubtitlesComponent {
  constructor(
    private dialogRef: MatDialogRef<PlayerAudioSubtitlesComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      currentResource: ResourceVm;
      player: Player;
    }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
